// extracted by css-extract-rspack-plugin
export default {"DashboardBackButton":"DashboardBackButton-module__DashboardBackButton___A2t4n"};